function blobToFile(theBlob: Blob, fileName: string): File {
  // TODO: you can do better
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const b: any = theBlob;
  b.lastModifiedDate = new Date();
  b.name = fileName;

  return theBlob as File;
}

export default blobToFile;
